import React from 'react';
import ClassNames from 'classnames';

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  container: {
    background: '#fff',
  },
  wrap: {
    padding: 24,
    width: '100%',
    // Уменьшаем padding на мобильных для компактности
    [theme.breakpoints.down(600)]: {
      padding: '8px 12px',
    },
  },
  maxWidth: {
    maxWidth: 1055,
  },
});

interface IProps extends WithStyles<typeof styles> {
  children: React.ReactNode;
  fullWidth?: boolean;
  noPadding?: boolean;
  direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
}

const PageContentWrap: React.FC<IProps> = ({
  classes,
  children,
  noPadding,
  fullWidth,
  direction,
  spacing,
}) => (
  <div className={ClassNames(classes.container, { [classes.wrap]: !noPadding }, { [classes.maxWidth]: !fullWidth })}>
    <Grid
      direction={direction || 'row'}
      container
      spacing={spacing || 3}
    >
      {children}
    </Grid>
  </div>
);

export default withStyles(styles)(PageContentWrap);
